// Configuração centralizada da aplicação
export const CONFIG = {
  // Backend API
  API_BASE_URL: process.env.REACT_APP_API_ROUTE || 'https://dev.scaladatacenters.com/api/',
  BASE_URL: process.env.REACT_APP_API_ROUTE || 'https://dev.scaladatacenters.com/api',
  PROCESSAR_ENDPOINT: '/processar',
  TIMEOUT: 120000, // 2 minutos para processamento
  
  // Azure AD / MSAL
  CLIENT_ID: process.env.REACT_APP_CLIENTID,
  TENANT_ID: process.env.REACT_APP_TENANTID,
  REDIRECT_URI: process.env.REACT_APP_REDIRECT || '/',
  
  // Environment
  NODE_ENV: process.env.NODE_ENV || 'development',
  EXTEND_ESLINT: process.env.EXTEND_ESLINT === 'true'
};

// Função helper para construir URLs da API
export const getApiUrl = (endpoint = '') => {
  const baseUrl = CONFIG.BASE_URL.endsWith('/') 
    ? CONFIG.BASE_URL.slice(0, -1) 
    : CONFIG.BASE_URL;
  
  const cleanEndpoint = endpoint.startsWith('/') 
    ? endpoint 
    : `/${endpoint}`;
    
  return `${baseUrl}${cleanEndpoint}`;
};

// Log de configuração (apenas em desenvolvimento)
if (CONFIG.NODE_ENV === 'development') {
  console.log('🔧 Configuração da aplicação:', {
    BASE_URL: CONFIG.BASE_URL,
    CLIENT_ID: CONFIG.CLIENT_ID ? '***configurado***' : 'não configurado',
    TENANT_ID: CONFIG.TENANT_ID ? '***configurado***' : 'não configurado',
    NODE_ENV: CONFIG.NODE_ENV
  });
}
